<template>
  <div class="paypal-confirm-component">
    <div class="model-container">
      <div class="title">Payment Failed</div>
      <div class="text">
        Please check if you have linked a bank account to your PayPal. Or you
        can continue to pay from your PayPal balance for one time subscription
        without auto renewal.
      </div>
      <hi-button type="primary" @click="subscribeClick" class="subscribe-btn"
        >Pay
      </hi-button>
      <hi-button type="text" class="cancel-btn" @click="cancel">{{
        $t("common.cancel")
      }}</hi-button>
    </div>
  </div>
</template>

<script>
import hiButton from "../../../components/button/Index";
import { paypalUrl } from "../../../service/payment";
import { showErrorMsg } from "../../../utils/errors";

export default {
  name: "PayPalConfirmComponent",
  components: { hiButton },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  methods: {
    /**
     * 支付按钮点击回调
     */
    async subscribeClick() {
      const loading = this.$loading();
      try {
        // 重新获取支付地址
        const url = await paypalUrl({
          id: this.params.billingCycleId,
          sale: true,
        });
        // 隐藏弹出
        this.showModal = false;
        window.location.href = url;
      } catch (e) {
        showErrorMsg(e);
        loading.close();
      }
    },
    /**
     * 点击取消按钮隐藏弹出
     */
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../../assets/style/theme.less";

.paypal-confirm-component {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  z-index: 401;
  .model-container {
    width: 640px;
    max-width: 90vw;
    background: white;
    padding: 0 15px;
    border-radius: 10px;
    .title {
      font-size: 18px;
      text-align: center;
      font-weight: 600;
      margin-top: 16px;
    }
    .text {
      font-size: 16px;
      padding: 10px 20px 22px 20px;
      line-height: 1.3;
      text-align: center;
    }
    // ios设备整体向上移动
    &.ios-platform {
      position: relative;
      bottom: 50px;
    }
    .subscribe-btn {
      width: 100%;
      height: 44px;
      background: @theme-color;
      &:active {
        opacity: 0.7;
      }
    }
    .cancel-btn {
      width: 100%;
      color: @theme-color;
      padding: 0;
      margin: 18px 0;
      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>
